import React from 'react';
import PropTypes from 'prop-types';

import { Radio } from './styles';

const Cell = ({
  name, checked, onChange,
}) => (
  <Radio
    toggle
    name={name}
    checked={checked}
    onChange={onChange}
  />
);

Cell.propTypes = {
  name: PropTypes.string.isRequired,
  checked: PropTypes.bool.isRequired,
  onChange: PropTypes.func.isRequired,
};

export default Cell;
